var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _setup.testappUse
      ? _c("div", [_c(_setup.testappRoot, { tag: "div" })], 1)
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "cruise" },
      [
        !_setup.route.meta.skipUplinks
          ? _c(
              "div",
              { staticClass: "uplinks" },
              [
                _c(
                  "router-link",
                  {
                    class: { act: _setup.active("river") },
                    attrs: { to: { name: "Search" } },
                  },
                  [_vm._v("\n      Речные круизы\n      ")]
                ),
                _vm._v(" "),
                _c(
                  "router-link",
                  {
                    class: { act: _setup.active("sea") },
                    attrs: { to: { name: "SearchSea" } },
                  },
                  [_vm._v("\n      Морские круизы\n      ")]
                ),
                _vm._v(" "),
                _c(
                  "router-link",
                  {
                    class: { act: _setup.active("ByHand") },
                    attrs: { to: { name: "ByHand" } },
                  },
                  [_vm._v("\n      Конструктор\n      ")]
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c("router-view"),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "versions" }, [
      _c(
        "a",
        {
          attrs: {
            href: _setup.gitlink,
            title: _setup.gittitle,
            target: "_blank",
          },
        },
        [_vm._v(_vm._s(_setup.ver))]
      ),
      _vm._v(" "),
      _c("span", { attrs: { title: _setup.gate } }, [_vm._v("gate")]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }